import { Login, Token } from 'src/app/types/accounts';
import config from 'src/config';
import { httpClient } from 'src/utils/axios';

export function postLogin(params: Login) {
  const authorization = `Base ${btoa(
    `${params.unidade}:${params.cpfCnpj}:${params.condominio}`
  )}`;
  return httpClient<Token>({
    method: 'POST',
    url: `${config.backend.apiAccounts}/api/v1/login`,
    headers: { Authorization: authorization }
  });
}

export function postForgotPassword(email: string, param: string) {
  return httpClient({
    method: 'POST',
    url: `${config.backend.apiAccounts}/api/v1/login/esquecisenha`,
    data: {
      email: email,
      param: param
    }
  });
}
